import { Box, Divider, Stack } from "@mui/material";
import { ReactNode, useState } from "react";
import { useRouteContext } from '../../hooks/use-route-context/UseRouteContext';
import { IRoute } from '../../routes/routes';
import { INavigationItem } from "../../services/navigation-data-service/Models";
import GroupHierarchyV2 from '../group-hierarchy/desktop/GroupHierarchyV2';
import NavigationFilterInput from "../navigation-filter/NavigationFilterInput";

export type NavigationGroupTreeProps = {
    // item: INavigationItem;
    id?: string;
    route: IRoute;
    actions?: ReactNode;
    onClick: ((item: INavigationItem, route: IRoute, shiftKey: boolean, ctrlKey: boolean) => void) | undefined;
    disableDefault?: boolean;
};

export default function NavigationGroupTree({
    // item,
    id,
    route,
    actions,
    onClick,
    disableDefault
}: NavigationGroupTreeProps) {
    const [filterText, setFilterText] = useState<string>("");
    const routeContext = useRouteContext();
      
    return (
        <Stack
            id={id}
            direction="column"
            sx={{
                flex: "1 1 auto",
                height: 1,
                overflow: "hidden",
            }}
        >
            <Stack
                direction="row"
                sx={{
                    alignItems: "center"
                }}
            >
                <NavigationFilterInput
                    value={filterText}
                    onChange={setFilterText}
                    sx={{
                        marginLeft: 2,
                        marginRight: 2,
                        marginTop: 1,
                        marginBottom: 1,

                        flex: "1 1 auto"
                    }}
                    autoFocus={true}
                />
                {actions}
            </Stack>
            <Divider />
            <Box
                sx={{
                    padding: 1,
                    overflowY: "auto",
                    flex: "1 1 auto"
                }}
            >
                <GroupHierarchyV2
                    onSelected={(selectedItem, shiftKey, ctrlKey) => {
                        onClick?.(selectedItem, route, shiftKey, ctrlKey);
                    }}
                    filterText={filterText}
                    defaultSelected={disableDefault ? undefined : routeContext.groupID as number}
                    disableDefault={disableDefault}
                    enableDynamicGroupRefresh={!disableDefault} />
            </Box>
        </Stack>
    );
}